import styled from 'styled-components';

export const StarQuestionBlock = styled.div`
  display: grid;
  gap: 12px;
`;

export const FeedbackTextFields = styled.div`
  display: grid;
  gap: 22px;
`;

export const ConsentLabel = styled.label`
  display: inline-flex;
  align-items: flex-start;
  gap: 10px;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  line-height: 1.35;

  input {
    margin-top: 2px;
  }
`;
